import { render, staticRenderFns } from "./AppRegistration.vue?vue&type=template&id=061770a3&"
import script from "./AppRegistration.vue?vue&type=script&lang=js&"
export * from "./AppRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports